import { FC } from "react";
import { IconProps } from "./types";

export const XMarkMedium: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="m14.274 12 3.412-3.411a1.072 1.072 0 0 0 0-1.517l-.758-.758a1.072 1.072 0 0 0-1.517 0L12 9.725 8.589 6.314a1.072 1.072 0 0 0-1.517 0l-.758.758a1.072 1.072 0 0 0 0 1.517L9.725 12l-3.411 3.412a1.072 1.072 0 0 0 0 1.516l.758.758a1.072 1.072 0 0 0 1.517 0L12 14.274l3.412 3.412a1.072 1.072 0 0 0 1.516 0l.758-.758a1.072 1.072 0 0 0 0-1.517L14.274 12z"
      fill={fill}
    />
  </svg>
);
